export const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_ID;

export const COOKIE_CONSENT_KEY = '__cookie_consent';
export const COOKIE_EXPIRES = 400;
export const COOKIE_CATEGORIES = {
  NECESSARY: 'necessary',
  ALL: 'all',
};
